<template>
	<v-combobox
		v-model="valueComputed"
		:items="itemsComputed"
		:rules="rules"
		:loading="loading || itemsLoading"
		chips
		small-chips
		:label="label"
		multiple
		placeholder="Select existing or type new"
	/>
</template>

<script>
import QuilityAPI from '@/store/API/QuilityAPI'

export default {
	props: {
		value: { type: Array, default: () => [] },
		rules: { type: Array, default: () => [] },
		label: { type: String, default: 'Subjects' },
		items: { type: Array, default: () => [] },
		loadItems: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
	},

	data () {
		return {
			tags: [],
			itemsLoading: false,
		}
	},

	created () {
		if (this.loadItems) {
			this.loadTags()
		}
	},

	watch: {
		loadItems (newValue) {
			if (newValue) {
				this.loadTags()
			}
		},
	},

	computed: {
		valueComputed: {
			get () { return this.$props.value },
			set (value) { this.$emit('input', value) }
		},
		itemsComputed () {
			const items = this.loadItems
				? this.tags
				: Array.isArray(this.items) ? this.items : []
			return items.length
				? items
				: [{ header: 'No existing subjects to select', disabled: true }]
		},
	},

	methods: {
		async loadTags () {
			this.itemsLoading = true
			const data = await QuilityAPI.getMarketingResourcesTagsList()
			if (!this.loadItems) { return }
			if (data.error) {
				this.showError('Could not load subjects', data.msg)
				this.tags = []
			} else {
				this.tags = data
			}
			this.itemsLoading = false
		},
	},
}
</script>
